import { z } from 'zod';
import { camelToSnake } from '../services/HelperService';

/**
 * Map Zod array-level validation errors to a flat Record keyed by
 * `${prefix}.${index}.${snake_case_field}`, matching the backend error format.
 *
 * Returns an empty object when validation succeeded.
 */
export function mapZodArrayErrors(
    result: { success: boolean; error?: z.ZodError },
    prefix: string,
): Record<string, string> {
    if (result.success || !result.error) return {};

    const errors: Record<string, string> = {};
    result.error.issues.forEach((issue) => {
        const [index, ...rest] = issue.path;
        const fieldName = rest.map(String).join('.');
        const snakeField = fieldName.split('.').map(p => camelToSnake(p)).join('.');
        errors[`${prefix}.${String(index)}.${snakeField}`] = issue.message;
    });
    return errors;
}
